"use client";
import { useLocalStorage } from "utils";

const ADMIN_VIEW_AS_CLIENT_KEY = "adminViewAsClient";

export function useAdminViewMode() {
  const [viewAsClient, setViewAsClient] = useLocalStorage<boolean>(
    ADMIN_VIEW_AS_CLIENT_KEY,
    false
  );

  function toggleViewAsClient() {
    const newValue = !viewAsClient;
    setViewAsClient(newValue);
    if (typeof window !== "undefined" && window.localStorage) {
      localStorage.setItem(ADMIN_VIEW_AS_CLIENT_KEY, JSON.stringify(newValue));
      // Navigate to /home so admin doesn't get stuck on an admin-only page
      // after switching to client view. Preserve locale prefix from URL.
      const pathParts = window.location.pathname.split("/").filter(Boolean);
      const locale = pathParts[0] || "en";
      window.location.href = `/${locale}/home`;
    }
  }

  return { viewAsClient, toggleViewAsClient };
}

export function useEffectiveIsAdmin(session: any): boolean {
  const [viewAsClient] = useLocalStorage<boolean>(
    ADMIN_VIEW_AS_CLIENT_KEY,
    false
  );
  const realIsAdmin = session?.user?.isAdmin || false;
  return realIsAdmin && !viewAsClient;
}